import { Role } from '../generated/graphql'

export const hasRequiredRole = (requiredRoles: Role[], userRoles?: string[]) => {
  return (
    userRoles?.length === 0 ||
    userRoles?.some((role) => requiredRoles.includes(role as unknown as Role))
  )
}
